import React from 'react'

import styles from './cardLogo.module.scss'

export type CreditCardBrand =
  | 'American Express'
  | 'Discover'
  | 'MasterCard'
  | 'Visa'
  | 'JCB'
  | 'Diners Club'

export const creditCardBrand = (brand: string): CreditCardBrand | undefined => {
  switch (brand) {
    case 'American Express':
      return 'American Express'
    case 'Discover':
      return 'Discover'
    case 'MasterCard':
      return 'MasterCard'
    case 'Visa':
      return 'Visa'
    case 'Diners Club':
      return 'Diners Club'
    case 'JCB':
      return 'JCB'
    default:
      return undefined
  }
}

type CreditCardLogoProps = {
  brand?: CreditCardBrand
  className?: string
}

const CreditCardLogo: React.FC<CreditCardLogoProps> = props => {
  const { brand, className } = props

  return (
    <div className={className}>
      {brand === 'American Express' && (
        <svg
          width="45"
          height="45"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 300 300"
        >
          <radialGradient
            id="a"
            cx="57.3882"
            cy="57.021"
            r="264.5797"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#9DD5F6" />
            <stop offset=".0711" stopColor="#98D3F5" />
            <stop offset=".1575" stopColor="#89CEF3" />
            <stop offset=".2516" stopColor="#70C6EF" />
            <stop offset=".3514" stopColor="#4EBBEA" />
            <stop offset=".4546" stopColor="#23ADE3" />
            <stop offset=".5" stopColor="#0DA6E0" />
            <stop offset="1" stopColor="#2E77BC" />
          </radialGradient>
          <path
            fill="url(#a)"
            d="M289.584 7.598H7.639v282.966h281.945v-93.386c1.12-1.619 1.673-3.69 1.673-6.222 0-2.898-.553-4.693-1.673-6.205"
          />
          <path
            fill="#FFF"
            d="M33.053 130.042l-5.424-13.217-5.393 13.217m130.307-5.263c-1.089.661-2.377.683-3.92.683h-9.627v-7.364h9.758c1.381 0 2.822.062 3.758.598 1.028.483 1.664 1.511 1.664 2.931 0 1.449-.605 2.615-1.633 3.152zm68.678 5.263l-5.484-13.217-5.454 13.217h10.938zm-128.02 14.306h-8.124l-.03-25.966-11.491 25.966h-6.958l-11.521-25.989v25.989H38.959l-3.045-7.395h-16.5l-3.076 7.395H7.731l14.191-33.154h11.774l13.478 31.39v-31.39h12.934l10.371 22.491 9.527-22.491H93.2v33.154zm32.379 0H99.107v-33.154h26.473v6.904h-18.548v5.976h18.103v6.796h-18.103v6.621h18.548v6.857zm37.326-24.225c0 5.286-3.528 8.017-5.584 8.837 1.734.66 3.215 1.826 3.92 2.792 1.119 1.649 1.312 3.122 1.312 6.083v6.513h-7.993l-.03-4.181c0-1.995.191-4.864-1.251-6.459-1.158-1.166-2.923-1.419-5.776-1.419h-8.507v12.059h-7.924v-33.154H149.3c4.05 0 7.034.107 9.596 1.588 2.507 1.481 4.01 3.643 4.01 7.341zm12.682 24.225h-8.086v-33.154h8.086v33.154zm93.808 0h-11.23l-15.021-24.884v24.884h-16.139l-3.084-7.395H207.46l-2.992 7.395h-9.273c-3.852 0-8.729-.852-11.491-3.667-2.785-2.815-4.234-6.628-4.234-12.657 0-4.917.866-9.412 4.272-12.964 2.562-2.646 6.574-3.866 12.035-3.866h7.672v7.104h-7.511c-2.892 0-4.525.43-6.098 1.964-1.351 1.396-2.278 4.035-2.278 7.51 0 3.552.706 6.113 2.179 7.786 1.22 1.312 3.437 1.71 5.523 1.71h3.559l11.169-26.073h11.874l13.417 31.359v-31.359h12.066l13.93 23.09v-23.09h8.117v33.153zM7.639 150.86h13.54l3.053-7.364h6.835l3.045 7.364h26.641v-5.63l2.378 5.654h13.83l2.378-5.738v5.714h66.208l-.031-12.088h1.281c.897.031 1.159.114 1.159 1.595v10.493h34.243v-2.814c2.762 1.48 7.058 2.814 12.711 2.814h14.406l3.083-7.364h6.835l3.015 7.364h27.761v-6.995l4.204 6.995h22.246v-46.24h-22.016v5.461l-3.083-5.461H228.77v5.461l-2.831-5.461h-30.515c-5.108 0-9.598.713-13.225 2.7v-2.7h-21.058v2.7c-2.308-2.048-5.453-2.7-8.95-2.7H75.258l-5.162 11.943-5.301-11.943H40.563v5.461l-2.662-5.461H17.235l-9.597 21.985v24.255zm281.945 24.455h-14.443c-1.442 0-2.4.054-3.207.599-.836.537-1.158 1.334-1.158 2.386 0 1.251.706 2.102 1.733 2.47.836.291 1.734.376 3.054.376l4.295.115c4.334.107 7.227.852 8.991 2.669.321.253.514.537.735.821m0 12.427c-1.925 2.815-5.676 4.242-10.754 4.242h-15.304v-7.111h15.242c1.512 0 2.57-.199 3.207-.821.552-.513.937-1.258.937-2.163 0-.966-.385-1.733-.968-2.193-.575-.506-1.412-.736-2.792-.736-7.441-.253-16.724.23-16.724-10.264 0-4.81 3.054-9.873 11.37-9.873h15.785v-6.598h-14.666c-4.426 0-7.641 1.06-9.918 2.708v-2.708h-21.693c-3.469 0-7.541.86-9.467 2.708v-2.708h-38.738v2.708c-3.083-2.224-8.285-2.708-10.686-2.708h-25.552v2.708c-2.439-2.362-7.863-2.708-11.169-2.708h-28.597l-6.544 7.082-6.129-7.082H63.706v46.272h41.914l6.743-7.194 6.352 7.194 25.836.023v-10.885h2.54c3.428.053 7.471-.085 11.038-1.627v12.488h21.31v-12.06h1.028c1.312 0 1.441.054 1.441 1.365v10.694h64.736c4.11 0 8.406-1.052 10.785-2.961v2.961h20.534c4.273 0 8.446-.599 11.621-2.133v-8.62zm-31.611-13.248c1.543 1.597 2.37 3.613 2.37 7.026 0 7.134-4.457 10.464-12.449 10.464h-15.435v-7.111h15.373c1.503 0 2.569-.199 3.237-.821.545-.513.936-1.258.936-2.163 0-.966-.423-1.733-.967-2.193-.606-.506-1.442-.736-2.822-.736-7.411-.253-16.692.23-16.692-10.264 0-4.81 3.022-9.873 11.33-9.873h15.887v7.058h-14.537c-1.441 0-2.378.054-3.175.599-.868.537-1.19 1.334-1.19 2.386 0 1.251.737 2.102 1.734 2.47.836.291 1.734.376 3.084.376l4.266.115c4.302.105 7.255.849 9.05 2.667zm-71.508-2.048c-1.06.629-2.371.683-3.913.683h-9.627v-7.448h9.758c1.411 0 2.823.03 3.782.599 1.027.537 1.641 1.564 1.641 2.983s-.614 2.562-1.641 3.183zm4.786 4.127c1.764.651 3.206 1.818 3.882 2.784 1.119 1.619 1.281 3.13 1.313 6.053v6.574h-7.956v-4.149c0-1.995.192-4.949-1.281-6.491-1.158-1.188-2.923-1.472-5.814-1.472h-8.469v12.112h-7.963v-33.162h18.296c4.012 0 6.934.177 9.535 1.565 2.501 1.511 4.074 3.581 4.074 7.364-.001 5.293-3.531 7.994-5.617 8.822zm10.011-17.751h26.449v6.858h-18.557v6.029h18.104v6.766h-18.104v6.598l18.557.03v6.881h-26.449v-33.162zm-53.467 15.304h-10.241v-8.445h10.333c2.861 0 4.847 1.166 4.847 4.066 0 2.868-1.894 4.379-4.939 4.379zm-18.134 14.842l-12.167-13.508 12.167-13.079v26.587zm-31.421-3.895H78.756v-6.598h17.398v-6.766H78.756v-6.029h19.868l8.668 9.664-9.052 9.729zm63.002-15.326c0 9.212-6.873 11.114-13.8 11.114h-9.888v11.123h-15.403l-9.758-10.978-10.141 10.978h-31.39v-33.162h31.873l9.75 10.87 10.08-10.87h25.322c6.289 0 13.355 1.741 13.355 10.925z"
          />
        </svg>
      )}
      {brand === 'Discover' && (
        <svg
          width="70"
          height="45"
          xmlns="http://www.w3.org/2000/svg"
          version="1"
          viewBox="0 0 48 48"
        >
          <path
            fill="#E1E7EA"
            d="M45 35c0 2.2-1.8 4-4 4H7c-2.2 0-4-1.8-4-4V13c0-2.2 1.8-4 4-4h34c2.2 0 4 1.8 4 4v22z"
          />
          <path
            fill="#FF6D00"
            d="M45 35c0 2.2-1.8 4-4 4H16s23.6-3.8 29-15v11zM22 24c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3z"
          />
          <path d="M11.2 21h1.1v6h-1.1v-6zm6 3c0 1.7 1.3 3 3 3 .5 0 .9-.1 1.4-.3v-1.3c-.4.4-.8.6-1.4.6-1.1 0-1.9-.8-1.9-2 0-1.1.8-2 1.9-2 .5 0 .9.2 1.4.6v-1.3c-.5-.2-.9-.4-1.4-.4-1.7.1-3 1.5-3 3.1zm13.4.9L29 21h-1.2l2.5 6h.6l2.5-6h-1.2l-1.6 3.9zm3.3 2.1h3.2v-1H35v-1.6h2v-1h-2V22h2.1v-1h-3.2v6zm7.6-4.2c0-1.1-.7-1.8-2-1.8h-1.7v6h1.1v-2.4h.1l1.6 2.4H42l-1.8-2.5c.8-.2 1.3-.8 1.3-1.7zm-2.3 1h-.3V22h.3c.7 0 1.1.3 1.1.9 0 .5-.3.9-1.1.9zM7.7 21H6v6h1.6c2.5 0 3.1-2.1 3.1-3 .1-1.8-1.2-3-3-3zm-.3 5h-.3v-4h.4c1.5 0 2.1 1 2.1 2 0 .4-.1 2-2.2 2zm7.9-2.7c-.7-.3-.9-.4-.9-.7 0-.4.4-.6.8-.6.3 0 .6.1.9.5l.6-.8c-.5-.5-1-.7-1.7-.7-1 0-1.8.7-1.8 1.7 0 .8.4 1.2 1.4 1.6.6.2 1.1.4 1.1.9s-.4.8-.9.8-1-.3-1.2-.8l-.7.7c.5.8 1.1 1.1 2 1.1 1.2 0 2-.8 2-1.9 0-.9-.4-1.3-1.6-1.8z" />
        </svg>
      )}
      {brand === 'JCB' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="70"
          height="48"
          version="1"
        >
          <path
            fill="#CFD8DC"
            d="M45 35c0 2.209-1.791 4-4 4H7c-2.209 0-4-1.791-4-4V13c0-2.209 1.791-4 4-4h34c2.209 0 4 1.791 4 4v22z"
          />
          <path
            fill="#3F51B5"
            d="M10.669 13C8.58 13 7 14.324 7 16.617V35h6.483C15.114 35 17 33.469 17 31.483V13h-6.331z"
          />
          <path
            fill="#E53935"
            d="M22.669 13C20.58 13 19 14.324 19 16.617V35h6.483C27.114 35 29 33.469 29 31.483V13h-6.331z"
          />
          <path
            fill="#388E3C"
            d="M34.669 13C32.58 13 31 14.324 31 16.617V35h6.483C39.114 35 41 33.469 41 31.483V13h-6.331z"
          />
          <path
            fill="#FAFAFA"
            d="M15.806 24.453c0 1.835-2.369 2.803-4.101 2.803-1.884 0-3.567-1.12-3.926-2.545h1.274c.152.866 1.021 1.475 1.987 1.475 1.07 0 1.834-.764 1.834-1.732v-3.311h2.931v3.31zm22.8-.415c.762 0 1.295-.759 1.295-1.519 0-.762-.663-1.422-1.425-1.422h-6.262v5.852h6.392c.863 0 1.522-.757 1.523-1.519 0-.759-.659-1.392-1.523-1.392zm-3.955-2.331h1.979c.504 0 .961.453.961.959 0 .509-.457.967-.961.967h-1.979v-1.926zm2.028 4.636h-2.027v-1.928h2.027c.508 0 .965.456.965.965 0 .505-.457.963-.965.963zm-8.868-4.167c-1.168-.27-2.286-.427-2.845-.427-1.218 0-2.181 1.017-2.181 2.303 0 1.292.963 2.311 2.181 2.311.559 0 1.677-.107 2.845-.38v1.021h-4.875c-1.522 0-2.79-1.342-2.79-2.952 0-1.607 1.268-2.948 2.79-2.948h4.875v1.072z"
          />
        </svg>
      )}
      {brand === 'MasterCard' && (
        <svg viewBox="0 0 146.8 120.41" width="70" height="45">
          <path d="M0 0h146.8v120.41H0z" className={styles.cls1} />
          <path
            d="M36.35 105.26v-6a3.56 3.56 0 0 0-3.76-3.8 3.7 3.7 0 0 0-3.36 1.7 3.51 3.51 0 0 0-3.16-1.7 3.16 3.16 0 0 0-2.8 1.42V95.7h-2.08v9.56h2.1V100a2.24 2.24 0 0 1 2.34-2.54c1.38 0 2.08.9 2.08 2.52v5.32h2.1V100a2.25 2.25 0 0 1 2.34-2.54c1.42 0 2.1.9 2.1 2.52v5.32zm31.07-9.56H64v-2.9h-2.1v2.9H60v1.9h1.94v4.4c0 2.22.86 3.54 3.32 3.54a4.88 4.88 0 0 0 2.6-.74l-.6-1.78a3.84 3.84 0 0 1-1.84.54c-1 0-1.38-.64-1.38-1.6V97.6h3.4zm17.74-.24a2.82 2.82 0 0 0-2.52 1.4V95.7h-2.06v9.56h2.08V99.9c0-1.58.68-2.46 2-2.46a3.39 3.39 0 0 1 1.3.24l.64-2a4.45 4.45 0 0 0-1.48-.26zm-26.82 1a7.15 7.15 0 0 0-3.9-1c-2.42 0-4 1.16-4 3.06 0 1.56 1.16 2.52 3.3 2.82l1 .14c1.14.16 1.68.46 1.68 1 0 .74-.76 1.16-2.18 1.16a5.09 5.09 0 0 1-3.18-1l-1 1.62a6.9 6.9 0 0 0 4.14 1.24c2.76 0 4.36-1.3 4.36-3.12s-1.26-2.56-3.34-2.86l-1-.14c-.9-.12-1.62-.3-1.62-.94s.68-1.12 1.82-1.12a6.16 6.16 0 0 1 3 .82zm55.71-1a2.82 2.82 0 0 0-2.52 1.4V95.7h-2.06v9.56h2.08V99.9c0-1.58.68-2.46 2-2.46a3.39 3.39 0 0 1 1.3.24l.64-2a4.45 4.45 0 0 0-1.48-.26zm-26.8 5a4.83 4.83 0 0 0 5.1 5 5 5 0 0 0 3.44-1.14l-1-1.68a4.2 4.2 0 0 1-2.5.86 3.07 3.07 0 0 1 0-6.12 4.2 4.2 0 0 1 2.5.86l1-1.68a5 5 0 0 0-3.44-1.14 4.83 4.83 0 0 0-5.1 5zm19.48 0V95.7h-2.08v1.16a3.63 3.63 0 0 0-3-1.4 5 5 0 0 0 0 10 3.63 3.63 0 0 0 3-1.4v1.16h2.08zm-7.74 0a2.89 2.89 0 1 1 2.9 3.06 2.87 2.87 0 0 1-2.9-3.06zm-25.1-5a5 5 0 0 0 .14 10 5.81 5.81 0 0 0 3.97-1.3l-1-1.54a4.55 4.55 0 0 1-2.78 1 2.65 2.65 0 0 1-2.86-2.34h7.1v-.8c0-3-1.86-5-4.54-5zm0 1.86a2.37 2.37 0 0 1 2.42 2.32h-5a2.46 2.46 0 0 1 2.54-2.32zm52.11 3.16v-8.62h-2v5a3.63 3.63 0 0 0-3-1.4 5 5 0 0 0 0 10 3.63 3.63 0 0 0 3-1.4v1.16h2zm3.47 3.39a1 1 0 0 1 .38.07 1 1 0 0 1 .31.2 1 1 0 0 1 .21.3.93.93 0 0 1 0 .74 1 1 0 0 1-.21.3 1 1 0 0 1-.31.2.94.94 0 0 1-.38.08 1 1 0 0 1-.9-.58.94.94 0 0 1 0-.74 1 1 0 0 1 .21-.3 1 1 0 0 1 .31-.2 1 1 0 0 1 .41-.07zm0 1.69a.71.71 0 0 0 .29-.06.75.75 0 0 0 .23-.16.74.74 0 0 0 0-1 .74.74 0 0 0-.23-.16.72.72 0 0 0-.29-.06.75.75 0 0 0-.29.06.73.73 0 0 0-.24.16.74.74 0 0 0 0 1 .74.74 0 0 0 .24.16.74.74 0 0 0 .32.06zm.06-1.19a.4.4 0 0 1 .26.08.25.25 0 0 1 .09.21.24.24 0 0 1-.07.18.35.35 0 0 1-.21.09l.29.33h-.23l-.27-.33h-.09v.33h-.19v-.88zm-.22.17v.24h.22a.21.21 0 0 0 .12 0 .1.1 0 0 0 0-.09.1.1 0 0 0 0-.09.21.21 0 0 0-.12 0zm-11-4.06a2.89 2.89 0 1 1 2.9 3.06 2.87 2.87 0 0 1-2.9-3.06zm-70.23 0V95.7H46v1.16a3.63 3.63 0 0 0-3-1.4 5 5 0 0 0 0 10 3.63 3.63 0 0 0 3-1.4v1.16h2.08zm-7.74 0a2.89 2.89 0 1 1 2.9 3.06 2.87 2.87 0 0 1-2.92-3.06z"
            className={styles.cls2}
          />
          <path d="M57.65 22.85h31.5v56.61h-31.5z" className={styles.cls3} />
          <path
            d="M59.65 51.16A35.94 35.94 0 0 1 73.4 22.85a36 36 0 1 0 0 56.61 35.94 35.94 0 0 1-13.75-28.3z"
            className={styles.cls4}
          />
          <path
            d="M131.65 51.16a36 36 0 0 1-58.25 28.3 36 36 0 0 0 0-56.61 36 36 0 0 1 58.25 28.3zm-3.44 22.3V72.3h.47v-.24h-1.19v.24h.51v1.16zm2.31 0v-1.4h-.36l-.42 1-.42-1H129v1.4h.26v-1.05l.39.91h.27l.39-.91v1.06z"
            className={styles.cls5}
          />
        </svg>
      )}
      {brand === 'Visa' && (
        <svg
          enableBackground="new 0 0 50 70"
          height="45px"
          version="1.1"
          viewBox="0 0 50 50"
          width="70px"
        >
          <polygon
            clipRule="evenodd"
            fill="#f4f5f9"
            fillRule="evenodd"
            points="17.197,32.598 19.711,17.592 23.733,17.592 21.214,32.598"
          />
          <path
            clipRule="evenodd"
            d="M35.768,17.967c-0.797-0.287-2.053-0.621-3.596-0.621 c-3.977,0-6.752,2.029-6.776,4.945c-0.023,2.154,1.987,3.358,3.507,4.08c1.568,0.738,2.096,1.201,2.076,1.861 c0,1.018-1.238,1.471-2.395,1.471c-1.604,0-2.455-0.232-3.773-0.787l-0.53-0.248l-0.547,3.348 c0.929,0.441,2.659,0.789,4.462,0.811c4.217,0,6.943-2.012,6.979-5.135c0.025-1.692-1.053-2.999-3.369-4.071 c-1.393-0.685-2.246-1.134-2.246-1.844c0-0.645,0.723-1.306,2.295-1.306c1.314-0.024,2.268,0.271,3.002,0.58l0.365,0.167 L35.768,17.967z"
            fill="#f4f5f9"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M46.055,17.616h-3.102c-0.955,0-1.688,0.272-2.117,1.24 l-5.941,13.767h4.201c0,0,0.688-1.869,0.852-2.262c0.469,0,4.547,0,5.133,0c0.123,0.518,0.49,2.262,0.49,2.262h3.711 L46.055,17.616 M41.1,27.277c0.328-0.842,1.609-4.175,1.609-4.175c-0.041,0.043,0.328-0.871,0.529-1.43l0.256,1.281 c0,0,0.773,3.582,0.938,4.324H41.1z"
            fill="#f4f5f9"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M13.843,17.616L9.905,27.842l-0.404-2.076 c-0.948-2.467-2.836-4.634-5.53-6.163l3.564,12.995h4.243l6.312-14.982H13.843z"
            fill="#f4f5f9"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M7.232,17.174H0.755l-0.037,0.333 c5.014,1.242,8.358,4.237,9.742,7.841l-1.42-6.884C8.798,17.507,8.105,17.223,7.232,17.174L7.232,17.174z"
            fill="#f4f5f9"
            fillRule="evenodd"
          />
        </svg>
      )}
    </div>
  )
}

export default CreditCardLogo
